import { useEffect, useState } from "react";
import ReactMarkdown from 'react-markdown';
import { getFAQs } from "../../lib/contentful";

export const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const faqData = await getFAQs();
        setFaqs(faqData);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div id="faqs" className="faq-section py-5">
      <div className="container">
        <div className="section-title text-center mb-5">
          <h2 className="display-4 fw-bold">Frequently Asked Questions</h2>
          <div className="underline mx-auto"></div>
        </div>

        {loading ? (
          <div className="text-center py-4">Loading questions...</div>
        ) : (
          <div className="faq-grid">
            {faqs.map((faq, i) => (
              <div key={faq.id || `faq-${i}`} className="faq-item mb-3">
                <div className="faq-card border rounded shadow-sm">
                  <div
                    className="faq-header p-3 d-flex justify-content-between align-items-center"
                    onClick={() => toggleFAQ(i)}
                    style={{ cursor: "pointer" }}
                  >
                    <h3 className="mb-0 text-bold">{faq.question}</h3>
                    <span className="faq-icon">
                      {activeIndex === i ? '−' : '+'}
                    </span>
                  </div>
                  <div
                    className={`faq-collapse ${activeIndex === i ? 'show' : ''}`}
                    style={{
                      maxHeight: activeIndex === i ? '1000px' : '0',
                      overflow: 'hidden',
                      transition: 'max-height 0.3s ease-in-out'
                    }}
                  >
                    <div className="faq-body p-3 border-top">
                      <ReactMarkdown>
                        {faq.answer}
                      </ReactMarkdown>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;